import React, { MouseEventHandler, ChangeEvent } from 'react';
import { Moment } from 'moment';
import Box from '@mui/material/Box';
import { SelectChangeEvent } from '@mui/material/Select';
import { IAlarmState } from '@core/interfaces/ISettings';
import { alarmAction } from '@core/interfaces/alarm-action';
import { BindedHandler } from '@core/interfaces/binded-handler';
import { lang } from '@lang/interfaces/lang';
import { IDateInput, INumberInput } from './useDeviceSettings';
import AlarmItemComponent from './Alarm-item.component';
import { alarm } from '@core/interfaces/alarm';

interface IProps {
    lang: lang;
    alarmAction: IAlarmState<number>;
    alarmActions: alarmAction[];
    alarmState: IAlarmState<boolean>;
    wakeUpTime: IAlarmState<IDateInput>;
    wakeUpActiveTime: IAlarmState<INumberInput>;
    timezone?: number;
    onAlarmStateChange: MouseEventHandler<HTMLButtonElement>;
    onWakeUpChange: BindedHandler<Moment>;
    onWakeUpError: BindedHandler<unknown>;
    onWakeUpActiveTimeChange: BindedHandler<ChangeEvent<HTMLInputElement>>;
    onAlarmActionChange: BindedHandler<SelectChangeEvent<number>>;
    onInputClick: () => void;
}

const Component: React.FC<IProps> = ({
    lang,
    alarmState,
    alarmAction,
    alarmActions,
    wakeUpTime,
    wakeUpActiveTime,
    timezone,
    onAlarmStateChange,
    onWakeUpChange,
    onWakeUpError,
    onWakeUpActiveTimeChange,
    onAlarmActionChange,
    onInputClick,
}: IProps) => {
    const alarms = Object.keys(alarmState) as alarm[];
    const alarmItems = alarms.map((name) => (
        <AlarmItemComponent
            key={name}
            name={name}
            lang={lang}
            alarmState={alarmState[name]!}
            alarmAction={alarmAction[name]!}
            alarmActions={alarmActions}
            wakeUpTime={wakeUpTime[name]!.value}
            wakeUpTimeError={wakeUpTime[name]!.error}
            wakeUpActiveTime={wakeUpActiveTime[name]!.value}
            wakeUpActiveTimeError={wakeUpActiveTime[name]!.error}
            timezone={timezone}
            onAlarmStateChange={onAlarmStateChange}
            onWakeUpChange={onWakeUpChange}
            onWakeUpError={onWakeUpError}
            onWakeUpActiveTimeChange={onWakeUpActiveTimeChange}
            onAlarmActionChange={onAlarmActionChange}
            onInputClick={onInputClick}
        />
    ));

    return (
        <Box className="device-settings__alarm-list" component="ul">
            {alarmItems}
        </Box>
    );
};

const AlarmSettingsComponent = React.memo(Component);

export default AlarmSettingsComponent;
